import produce from "immer";
import {  CommAutoApplicationPolicyReqActions } from ".";
import { IStoreState } from "../../initialStoreState";
import { initialCommAutoPolicyChangeReqState } from "./commAutoPolicyChangeReq.types";
import { CLEAR_COMM_AUTO_POLICY_APPLICATION_STATE, FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_FAILED, FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_PROGRESS, FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_SUCCESSS, FETCH_COMM_AUTO_POLICY_CHANGE_LIST_FAILED, FETCH_COMM_AUTO_POLICY_CHANGE_LIST_PROGRESS, FETCH_COMM_AUTO_POLICY_CHANGE_LIST_SUCCESS } from "./commautoPolicyChangeReqActions";
import { LoadState } from "../../../constants/enums";

export const commAutoPolicyChangeReqReducer = (
  state: IStoreState["commAuto"]["policyChangeReq"] = initialCommAutoPolicyChangeReqState,
  action: CommAutoApplicationPolicyReqActions
) => {
  switch (action.type) {
    case FETCH_COMM_AUTO_POLICY_CHANGE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_COMM_AUTO_POLICY_CHANGE_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = list;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_COMM_AUTO_POLICY_CHANGE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }

    case FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.error = null;
        draftState.policyChangeData =
        initialCommAutoPolicyChangeReqState["policyChangeData"];
      });
      return newState;
    }
    case FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_SUCCESSS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.policyChangeData = data;
      });
      return newState;
    }
    case FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = error || null;
        draftState.policyChangeData =
        initialCommAutoPolicyChangeReqState["policyChangeData"];
      });
      return newState;
    }

    case CLEAR_COMM_AUTO_POLICY_APPLICATION_STATE: // return initialAutomobilePolicyChangeReqState;
    {
      return initialCommAutoPolicyChangeReqState;
    }

    default: {
      return state;
    }
  }
};
